import { STATE } from '../constants/stateClasses';
import { breakpoints } from '../utils/breakpoints';
import { scroll } from './locomotive';

const selectors = {
  header: '.js-header',
  section: '.js-sticky-circle-section',
  smallCircle: '.js-sticky-small-circle',
  largeCircle: '.js-sticky-large-circle',
  smallCircleTitle: '.js-sticky-small-circle-title',
  largeCircleTitle: '.js-sticky-large-circle-title',
};

const classNames = {
  scrolled: 'l-header--scrolled',
};

const handleStickyCircleSection = () => {
  if (window.innerWidth < breakpoints.tablet) return;

  const section = document.querySelector(selectors.section);

  if (section === null) return;

  const header = document.querySelector(selectors.header);
  const smallCircle = section.querySelector(selectors.smallCircle);
  const largeCircle = section.querySelector(selectors.largeCircle);

  const smallCircleTitle = smallCircle?.querySelector(selectors.smallCircleTitle);

  const toggleSmallCircleTitle = (force = undefined) => {
    const titleContainsClassname = smallCircleTitle.classList.contains(STATE.active);

    if (titleContainsClassname && force) return;
    if (!titleContainsClassname && !force) return;

    smallCircleTitle.classList.toggle(STATE.active, force);
  };

  const toggleSmallCircleContent = (force = undefined) => {
    const circleContainsClassname = smallCircle.classList.contains(STATE.active);

    if (circleContainsClassname && force) return;
    if (!circleContainsClassname && !force) return;

    smallCircle.classList.toggle(STATE.active, force);
  };

  const toggleLargeCircleContent = (force = undefined) => {
    const circleContainsClassname = largeCircle.classList.contains(STATE.active);

    if (circleContainsClassname && force) return;
    if (!circleContainsClassname && !force) return;

    largeCircle.classList.toggle(STATE.active, force);
  };

  const handleScroll = (e) => {
    const stickySection = e.currentElements['sticky-circle-section'];

    if (stickySection === undefined) return;

    const { progress } = stickySection;

    header.classList.add(classNames.scrolled);

    if (progress < 0.1) {
      // Hide small circle content
      toggleSmallCircleContent(false);

      // Show small circle title
      toggleSmallCircleTitle(true);
    } else if (progress < 0.55) {
      // Hide small circle title
      toggleSmallCircleTitle(false);

      // Hide large circle content
      toggleLargeCircleContent(false);

      // Show small circle content
      toggleSmallCircleContent(true);
    } else {
      // Hide small circle content
      toggleSmallCircleContent(false);

      // Show large circle content
      toggleLargeCircleContent(true);
    }
  };

  scroll?.on('scroll', handleScroll);
};
export default handleStickyCircleSection;
